import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["brazilianPanel", "foreignPanel", "brazilianInput", "foreignInput"]

  connect() {
    this.toggle()
  }

  toggle() {
    const foreign = this.foreignSelected()

    if (this.hasBrazilianPanelTarget) this.brazilianPanelTarget.hidden = foreign
    if (this.hasForeignPanelTarget) this.foreignPanelTarget.hidden = !foreign
    if (this.hasBrazilianInputTarget) {
      this.brazilianInputTarget.disabled = foreign
      this.brazilianInputTarget.required = !foreign
    }
    if (this.hasForeignInputTarget) {
      this.foreignInputTarget.disabled = !foreign
      this.foreignInputTarget.required = foreign
    }
  }

  foreignSelected() {
    const checked = this.element.querySelector("input[type=radio]:checked")
    return checked?.value === "foreign"
  }
}
